import { yupResolver } from "@hookform/resolvers/yup";
import dayjs from "dayjs";
import { array, mixed, object, string } from "yup";

export const defaultValues = {
  id: "",
  code: "",
  name: "",
  unit: "",
  goods: [],
};

export const comboItemResolver = yupResolver(
  object({
    name: string().required("Vui lòng nhập tên combo item!"),
    unit: string().required("Vui lòng nhập tên đơn vị tính!"),
    goods: array()
      .of(object())
      .min(1, "Vui lòng thêm hàng hóa!")
      .required("Vui lòng thêm hàng hóa!"),
  }),
);

export const comboDefaultValues = {
  code: "",
  name: "",
  unit: "",
  note: "",
  file_id: "",
  from: dayjs().toDate(),
  to: dayjs().endOf("month").toDate(),
  items: [],
  cost: 0,
  stores: [],
};

export const comboResolver = yupResolver(
  object({
    name: string().required("Vui lòng nhập tên combo!"),
    unit: string().required("Vui lòng nhập đơn vị tính!"),
    from: mixed().test(
      "date-valid",
      "Ngày bắt đầu và ngày kết thúc chưa hợp lệ!",
      (value, context) => {
        const values = context.parent;
        if (dayjs(values.from).isAfter(dayjs(values.to))) return false;

        return true;
      },
    ),
    product_file: mixed().test(
      "is-valid",
      "Vui lòng upload hình ảnh combo!",
      (value) => {
        if (!!value) {
          return true;
        } else return false;
      },
    ),
    portion_file: mixed().test(
      "is-valid",
      "Vui lòng upload hình ảnh định mức!",
      (value) => {
        if (!!value) {
          return true;
        } else return false;
      },
    ),
    items: array()
      .of(object())
      .min(1, "Vui lòng thêm combo item!")
      .required("Vui lòng thêm combo item!"),
    stores: array()
      .of(object())
      .min(1, "Vui lòng thêm chi nhánh!")
      .required("Vui lòng thêm chi nhánh!"),
  }),
);
